<template>
  <div class="ai_ncmj_main">
    <h1>AI南昌麻将算分规则</h1>
    <p class="desc">
      基于chatGPT模型，AI回答南昌麻将算分结果，知识库文档有麻将大师凡凡专业提供～
    </p>
    <p class="dream">我的梦想是五八四十精吊德国德中德！</p>
    <!-- 添加输入框和按钮 -->
    <div class="input_container">
      <el-input
        v-model="query"
        placeholder="让我看看是多大的牌？！"
        @keyup.enter="fetchResults"
      ></el-input>
    </div>

    <el-button type="primary" @click="getNcmjByAI">查询</el-button>
    <!-- 加载状态 -->
    <div
      v-if="loading"
      class="loading"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></div>
    <!-- 结果显示区 -->
    <div v-if="!loading && result" class="result-box">{{ result }}</div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "AiNcmj",
  metaInfo: {
    title: "AI对答南昌麻将算分", // 设置页面标题
    meta: [
      { name: "description", content: "大鸡排工作室出品！" } // 设置页面描述
    ]
  },
  data() {
    return {
      query: "", // 用户输入
      loading: false, // 是否正在加载
      result: null // 显示的结果
    };
  },
  methods: {
    getNcmjByAI() {
      if (!this.query) return;
      this.loading = true;
      this.result = null;
      api.getNcmjByAI(this.query).then(res => {
        this.loading = false;
        const { code, data } = res;
        if (code == 200) {
          this.result = data.answer;
        }
      });
    }
  }
};
</script>

<style scoped>
.ai_ncmj_main {
  min-height: calc(100vh - 160px);
}
.desc {
  margin: 0 10%;
}
.dream {
  font-size: small;
  color: grey;
}

.input_container {
  margin: 0 20% 20px;
}

.loading {
  margin: 70px 0;
}
.result-box {
  margin: 70px 10%;
  text-align: left;
}
@media screen and (max-width: 540px) {
  .input_container {
    width: 50%;
    margin: 0 auto 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AiNcmj.vue